(function (upp) {
    'use strict';

    //Directive to handle events of each product of the order:
    // * remove action
    // * change of amount (selectedStock).
    upp.directive('cartOrderProduct', ['appi', 'cartService',
        function (appi, cartService) {

            var removeProduct = function ($scope, product) {
                cartService.remove(product);

                //Refresh the ui
                $scope.$apply();
            };

            var updateNavBarCount = function () {
                cartService.updateNavBarCount();
            };

            var broadcastRecalculatePricesEvent = function () {
                appi.utils.broadcast('cart:recalculatePrices');
            };

            var configStockChange = function ($scope) {
                $scope.$watch('product.selectedStock', function (amount) {
                    if (!isNaN(amount) && ($scope.product.selectedVariation.stock == -1 || $scope.product.selectedVariation.stock >= amount)) {
                        updateNavBarCount();
                        broadcastRecalculatePricesEvent();
                    }
                });

                $scope.updateStockProduct = function (product, variantStock) {
                    product.selectedStock += variantStock;
                    cartService.update();
                };

            };

            var configProductRemoval = function ($scope, $element) {
                var removeProductFromOrder = function (productElto, product) {
                    productElto.fadeOut(1000, function () {
                        removeProduct($scope, product);
                        broadcastRecalculatePricesEvent();
                    });
                };

                var showConfirmationModalMessage = function (removalCallback) {
                    appi.ui.modalMessage({
                        title : 'CART.ORDER.REMOVAL-CONFIRM.TITLE',
                        message : "CART.ORDER.REMOVAL-CONFIRM.MSG",
                        closeButton : {
                            text : "CANCEL"
                        },
                        confirmButton : {
                            text : "YES",
                            callback : removalCallback
                        }
                    }).then(function(modal) {
                       modal.show();
                    });
                };

                $scope.removeFromOrder = function (product) {
                    showConfirmationModalMessage(function () {
                        removeProductFromOrder($element, product);
                    });
                };
            };

            return {
                restrict : 'C',
                link : function ($scope, $element) {
                    configStockChange($scope);
                    configProductRemoval($scope, $element);
                }
            }
        }]);

})(upp);



// WEBPACK FOOTER //
// ./src/app/modules/cart/directives/cart-remove_order-directive.js